
export default {
  name: 'ComponentButton',
  components: {},
  props: {
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: false,
      default: null
    },
    variant: {
      type: String,
      required: false,
      default: 'primary'
    },
    target: {
      type: String,
      required: false,
      default: '_blank'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    arrow: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    href() {
      return this.link && this.link.includes('http') ? this.link : null
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
